import axios from 'axios';
import qs from 'qs';
import { ActiveLinkApiError } from '../errors';

function errorHandler(error) {
  if (error.isAxiosError && error.response) {
    throw new ActiveLinkApiError(error.response.statusText, error.response.status);
  } else {
    throw new ActiveLinkApiError(error.message);
  }
}

const activeLinkApiBase = '/api/v1/activeLink';

const ALApi = axios.create({
  baseURL: activeLinkApiBase,
  paramsSerializer: (params) => {
    return qs.stringify(params);
  }
});

export async function getActiveLinkWhiteList() {
  try {
    const res = await ALApi.get('/getActiveLinkWhiteList');
    return res.data.data.whiteList;
  } catch (error) {
    errorHandler(error);
  }
}
